import {User} from 'firebase';
import Vue from 'vue';
import * as firebase from 'firebase';
import GeoPoint = firebase.firestore.GeoPoint;
import {DateTime} from 'luxon';
import Timestamp = firebase.firestore.Timestamp;
import CollectionReference = firebase.firestore.CollectionReference;
import * as _ from 'lodash';

// TODO: fix this file so these rules don't need to be disabled
/* tslint:disable:max-classes-per-file */
/* tslint:disable:class-name */
/* tslint:disable:variable-name */
/* tslint:disable:no-bitwise */
/* tslint:disable:no-console */

export interface RootState {
    signedIn: boolean;
    currentUser: User | undefined;

}

export interface login {
    email: string;
    password: string;
}


export interface lookup {
    value: string[] | number [] | LookupDistance[] | undefined;
    values: LookupIcon[] | undefined;
}

export class Lookup implements lookup {
    public value: string[] | number[] | LookupDistance[] | undefined;
    public values: LookupIcon[] | undefined;

    constructor(data: any) {
        if (data.value) {
            this.value = data.value;
        }
        if (data.values) {
            this.values = _.map(data.values, (d: lookupIcon) => {
                return new LookupIcon(d);
            });
        }

    }

}

export class HaversineFomula {

    get distance() {

        const dLat: number = this.toRadian(this.fromLocation.latitude - this.toLocation.latitude);
        const dLon: number = this.toRadian(this.fromLocation.longitude - this.toLocation.longitude);
        const a: number = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(this.toRadian(this.toLocation.latitude)) *
                Math.cos(this.toRadian(this.fromLocation.latitude)) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c: number = 2 * Math.asin(Math.min(1, Math.sqrt(a)));
        const d: number = this.R * c;
        return d;
    }
    public fromLocation: GeoPoint;
    public toLocation: GeoPoint;

    public R: number = 20908800;

    constructor(loc1: GeoPoint, loc2: GeoPoint) {
        this.fromLocation = loc1;
        this.toLocation = loc2;
    }

    public toRadian(val: number): number {
        return (Math.PI / 180) * val;
    }

}

export interface LookupDistance {
    distance: string | undefined;
    display: string | undefined;
}

export interface lookupIcon {
    icon: string | undefined;
    display: string | undefined;
    url: string | undefined;
}

export class LookupIcon implements lookupIcon {

    public display: string | undefined;
    public icon: string | undefined;
    public url: string | undefined;
    constructor(icon: lookupIcon) {
        this.display = icon.display;
        this.icon = icon.icon;
        this.url = '';
    }

    public async getIcon() {
        if (this.icon) {
            this.url = await Vue.prototype.$storage.ref(`icons/${this.icon}`).getDownloadURL();
        }
    }


}


export class baseClass {
    public static staticToPlainObj(obj: any): object {
        return JSON.parse(JSON.stringify(obj));
    }
    public static convertToJSDate(date: any): Date | undefined {
        if (typeof date === 'string') {
            return DateTime.fromISO(date).toJSDate();
        } else if (date instanceof Timestamp) {
            return date.toDate();
        } else if (date instanceof Date) {
            return date;
        } else if (date instanceof DateTime) {
            return date.toJSDate();
        } else {
            return undefined;
        }
    }
    public toPlainObj(): object {
        return JSON.parse(JSON.stringify(this));
    }
}
export class geoQuery {















// Default geohash length
    public g_GEOHASH_PRECISION: number = 10;

// Characters used in location geohashes
    public g_BASE32: string = '0123456789bcdefghjkmnpqrstuvwxyz';

// The meridional circumference of the earth in meters
    public g_EARTH_MERI_CIRCUMFERENCE: number = 40007860;

// Length of a degree latitude at the equator
    public g_METERS_PER_DEGREE_LATITUDE: number = 110574;

// Number of bits per geohash character
    public g_BITS_PER_CHAR: number = 5;

// Maximum length of a geohash in bits
    public g_MAXIMUM_BITS_PRECISION: number = 22 * this.g_BITS_PER_CHAR;

// Equatorial radius of the earth in meters
    public g_EARTH_EQ_RADIUS: number = 6378137.0;

// The following value assumes a polar radius of
// var g_EARTH_POL_RADIUS = 6356752.3;
// The formulate to calculate g_E2 is
// g_E2 == (g_EARTH_EQ_RADIUS^2-g_EARTH_POL_RADIUS^2)/(g_EARTH_EQ_RADIUS^2)
// The exact value is used here to avoid rounding errors
    public g_E2: number =  0.00669447819799;

// Cutoff for rounding errors on double calculations
    public g_EPSILON: number = 1e-12;

    /**
     * Validates the inputted key and throws an error if it is invalid.
     *
     * @param {string} key The key to be verified.
     */
    public validateKey(key: string | number) {
        let error;

        if (typeof key !== 'string') {
            error = 'key must be a string';
        } else if (key.length === 0) {
            error = 'key cannot be the empty string';
        } else if (1 + this.g_GEOHASH_PRECISION + key.length > 755) {
            // Firebase can only stored child paths up to 768 characters
            // The child path for this key is at the least: "i/<geohash>key"
            error = 'key is too long to be stored in Firebase';
        } else if (/[\[\].#$\/\u0000-\u001F\u007F]/.test(key)) {
            // Firebase does not allow node keys to contain the following characters
            error = 'key cannot contain any of the following characters: . # $ ] [ /';
        }

        if (typeof error !== 'undefined') {
            throw new Error('Invalid GeoFire key \'' + key + '\': ' + error);
        }
    }
    /**
     * Validates the inputted location and throws an error if it is invalid.
     *
     * @param {Array.<number>} location The [latitude, longitude] pair to be verified.
     */

    /**
     * Validates the inputted geohash and throws an error if it is invalid.
     *
     * @param {string} geohash The geohash to be validated.
     */
    public validateGeohash(geohash: string) {
        let error;


        if (geohash.length === 0) {
            error = 'geohash cannot be the empty string';
        } else {
            for (let i = 0, length = geohash.length; i < length; ++i) {
                if (this.g_BASE32.indexOf(geohash[i]) === -1) {
                    error = 'geohash cannot contain "' + geohash[i] + '"';
                }
            }
        }

        if (typeof error !== 'undefined') {
            throw new Error('Invalid GeoFire geohash \'' + geohash + '\': ' + error);
        }
    }
    /**
     * Converts degrees to radians.
     *
     * @param {number} degrees The number of degrees to be converted to radians.
     * @return {number} The number of radians equal to the inputted number of degrees.
     */
    public degreesToRadians(degrees: number) {
        if (isNaN(degrees)) {
            throw new Error('Error: degrees must be a number');
        }

        return (degrees * Math.PI / 180);
    }
    /**
     * Generates a geohash of the specified precision/string length from the  [latitude, longitude]
     * pair, specified as an array.
     *
     * @param {Array.<number>} location The [latitude, longitude] pair to encode into a geohash.
     * @param {number=} precision The length of the geohash to create. If no precision is
     * specified, the global default is used.
     * @return {string} The geohash of the inputted location.
     */
    public encodeGeohash(location: any, precision: number | null): string {

        // Use the global precision default if no precision is specified
        precision = precision || this.g_GEOHASH_PRECISION;

        const latitudeRange = {
            min: -90,
            max: 90,
        };
        const longitudeRange = {
            min: -180,
            max: 180,
        };
        let hash = '';
        let hashVal = 0;
        let bits = 0;
        let even: boolean = true;

        while (hash.length < precision) {
            const val = even ? location[1] : location[0];
            const range = even ? longitudeRange : latitudeRange;
            const mid = (range.min + range.max) / 2;

            /* jshint -W016 */
            if (val > mid) {
                hashVal = (hashVal << 1) + 1;
                range.min = mid;
            } else {
                hashVal = (hashVal << 1) + 0;
                range.max = mid;
            }
            /* jshint +W016 */

            even = !even;
            if (bits < 4) {
                bits++;
            } else {
                bits = 0;
                hash += this.g_BASE32[hashVal];
                hashVal = 0;
            }
        }

        return hash;
    }
    /**
     * Calculates the number of degrees a given distance is at a given latitude.
     *
     * @param {number} distance The distance to convert.
     * @param {number} latitude The latitude at which to calculate.
     * @return {number} The number of degrees the distance corresponds to.
     */
    public metersToLongitudeDegrees(distance: any, latitude: any) {
        const radians = this.degreesToRadians(latitude);
        const num = Math.cos(radians) * this.g_EARTH_EQ_RADIUS * Math.PI / 180;
        const denom = 1 / Math.sqrt(1 - this.g_E2 * Math.sin(radians) * Math.sin(radians));
        const deltaDeg = num * denom;
        if (deltaDeg  < this.g_EPSILON) {
            return distance > 0 ? 360 : 0;
        } else {
            return Math.min(360, distance / deltaDeg);
        }
    }
    /**
     * Calculates the bits necessary to reach a given resolution, in meters, for the longitude at a
     * given latitude.
     *
     * @param {number} resolution The desired resolution.
     * @param {number} latitude The latitude used in the conversion.
     * @return {number} The bits necessary to reach a given resolution, in meters.
     */
    public longitudeBitsForResolution(resolution: any, latitude: any) {
        const degs = this.metersToLongitudeDegrees(resolution, latitude);
        return (Math.abs(degs) > 0.000001) ?  Math.max(1, Math.log2(360 / degs)) : 1;
    }
    /**
     * Calculates the bits necessary to reach a given resolution, in meters, for the latitude.
     *
     * @param {number} resolution The bits necessary to reach a given resolution, in meters.
     */
    public latitudeBitsForResolution(resolution: any) {
        return Math.min(Math.log2(this.g_EARTH_MERI_CIRCUMFERENCE / 2 / resolution), this.g_MAXIMUM_BITS_PRECISION);
    }
    /**
     * Wraps the longitude to [-180,180].
     *
     * @param {number} longitude The longitude to wrap.
     * @return {number} longitude The resulting longitude.
     */
    public wrapLongitude(longitude: any) {
        if (longitude <= 180 && longitude >= -180) {
            return longitude;
        }
        const adjusted = longitude + 180;
        if (adjusted > 0) {
            return (adjusted % 360) - 180;
        } else {
            return 180 - (-adjusted % 360);
        }
    }
    /**
     * Calculates the maximum number of bits of a geohash to get a bounding box that is larger than a
     * given size at the given coordinate.
     *
     * @param {Array.<number>} coordinate The coordinate as a [latitude, longitude] pair.
     * @param {number} size The size of the bounding box.
     * @return {number} The number of bits necessary for the geohash.
     */
    public boundingBoxBits(coordinate: any, size: any) {
        const latDeltaDegrees = size / this.g_METERS_PER_DEGREE_LATITUDE;
        const latitudeNorth = Math.min(90, coordinate[0] + latDeltaDegrees);
        const latitudeSouth = Math.max(-90, coordinate[0] - latDeltaDegrees);
        const bitsLat = Math.floor(this.latitudeBitsForResolution(size)) * 2;
        const bitsLongNorth = Math.floor(this.longitudeBitsForResolution(size, latitudeNorth)) * 2 - 1;
        const bitsLongSouth = Math.floor(this.longitudeBitsForResolution(size, latitudeSouth)) * 2 - 1;
        return Math.min(bitsLat, bitsLongNorth, bitsLongSouth, this.g_MAXIMUM_BITS_PRECISION);
    }
    /**
     * Calculates eight points on the bounding box and the center of a given circle. At least one
     * geohash of these nine coordinates, truncated to a precision of at most radius, are guaranteed
     * to be prefixes of any geohash that lies within the circle.
     *
     * @param {Array.<number>} center The center given as [latitude, longitude].
     * @param {number} radius The radius of the circle.
     * @return {Array.<Array.<number>>} The eight bounding box points.
     */
    public boundingBoxCoordinates(center: any, radius: any) {
        const latDegrees = radius / this.g_METERS_PER_DEGREE_LATITUDE;
        const latitudeNorth = Math.min(90, center[0] + latDegrees);
        const latitudeSouth = Math.max(-90, center[0] - latDegrees);
        const longDegsNorth = this.metersToLongitudeDegrees(radius, latitudeNorth);
        const longDegsSouth = this.metersToLongitudeDegrees(radius, latitudeSouth);
        const longDegs = Math.max(longDegsNorth, longDegsSouth);
        const ret = [
            [center[0], center[1]],
            [center[0], this.wrapLongitude(center[1] - longDegs)],
            [center[0], this.wrapLongitude(center[1] + longDegs)],
            [latitudeNorth, center[1]],
            [latitudeNorth, this.wrapLongitude(center[1] - longDegs)],
            [latitudeNorth, this.wrapLongitude(center[1] + longDegs)],
            [latitudeSouth, center[1]],
            [latitudeSouth, this.wrapLongitude(center[1] - longDegs)],
            [latitudeSouth, this.wrapLongitude(center[1] + longDegs)],
        ];
        return ret;
    }
    /**
     * Calculates the bounding box query for a geohash with x bits precision.
     *
     * @param {string} geohash The geohash whose bounding box query to generate.
     * @param {number} bits The number of bits of precision.
     * @return {Array.<string>} A [start, end] pair of geohashes.
     */
    public geohashQuery(geohash: any, bits: any) {
        const precision = Math.ceil(bits / this.g_BITS_PER_CHAR);
        if (geohash.length < precision) {
            console.warn('geohash.length < precision: ' + geohash.length +
                ' < ' + precision + ' bits=' + bits + ' g_BITS_PER_CHAR=' + this.g_BITS_PER_CHAR);
            return [geohash, geohash + '~'];
        }
        geohash = geohash.substring(0, precision);
        const base = geohash.substring(0, geohash.length - 1);
        const lastValue = this.g_BASE32.indexOf(geohash.charAt(geohash.length - 1));
        const significantBits = bits - (base.length * this.g_BITS_PER_CHAR);
        const unusedBits = (this.g_BITS_PER_CHAR - significantBits);
        /*jshint bitwise: false*/
        // delete unused bits
        const startValue = (lastValue >> unusedBits) << unusedBits;
        const endValue = startValue + (1 << unusedBits);
        /*jshint bitwise: true*/
        if (endValue >= this.g_BASE32.length) {
            console.warn('endValue > 31: endValue=' + endValue +
                ' < ' + precision + ' bits=' + bits + ' g_BITS_PER_CHAR=' + this.g_BITS_PER_CHAR);
            return [base + this.g_BASE32[startValue], base + '~'];
        } else {
            return [base + this.g_BASE32[startValue], base + this.g_BASE32[endValue]];
        }
    }
    /**
     * Calculates a set of queries to fully contain a given circle. A query is a [start, end] pair
     * where any geohash is guaranteed to be lexiographically larger then start and smaller than end.
     *
     * @param {Array.<number>} center The center given as [latitude, longitude] pair.
     * @param {number} radius The radius of the circle.
     * @return {Array.<Array.<string>>} An array of geohashes containing a [start, end] pair.
     */
    public geohashQueries(center: any, radius: any): any {
        const self = this;
        const queryBits = Math.max(1, this.boundingBoxBits(center, radius));
        const geohashPrecision = Math.ceil(queryBits / this.g_BITS_PER_CHAR);
        const coordinates = this.boundingBoxCoordinates(center, radius);
        const queries = coordinates.map( (coordinate: any) => {
            return self.geohashQuery(self.encodeGeohash(coordinate, geohashPrecision), queryBits);
        });
        // remove duplicates
        return queries.filter( (query, index) => {
            return !queries.some( (other, otherIndex) => {
                return index > otherIndex && query[0] === other[0] && query[1] === other[1];
            });
        });
    }


    /**
     * Returns the key of a Firebase snapshot across SDK versions.
     *
     * @param {DataSnapshot} snapshot A Firebase snapshot.
     * @return {string|null} key The Firebase snapshot's key.
     */
    public getKey(snapshot: any): any {
        let key;
        if (typeof snapshot.key === 'function') {
            key = snapshot.key();
        } else if (typeof snapshot.key === 'string' || snapshot.key === null) {
            key = snapshot.key;
        } else {
            key = snapshot.name();
        }
        return key;
    }

///

/// Part from geoFire.js

    /**
     * Static method which calculates the distance, in kilometers, between two locations,
     * via the Haversine formula. Note that this is approximate due to the fact that the
     * Earth's radius varies between 6356.752 km and 6378.137 km.
     *
     * @param {Array.<number>} location1 The [latitude, longitude] pair of the first location.
     * @param {Array.<number>} location2 The [latitude, longitude] pair of the second location.
     * @return {number} The distance, in kilometers, between the inputted locations.
     */
    public distance(location1: any, location2: any): any {

        const radius = 6371; // Earth's radius in kilometers
        const latDelta = this.degreesToRadians(location2[0] - location1[0]);
        const lonDelta = this.degreesToRadians(location2[1] - location1[1]);

        const a = (Math.sin(latDelta / 2) * Math.sin(latDelta / 2)) +
            (Math.cos(this.degreesToRadians(location1[0])) * Math.cos(this.degreesToRadians(location2[0])) *
                Math.sin(lonDelta / 2) * Math.sin(lonDelta / 2));

        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        return radius * c;
    }



    public getQueriesForDocumentsAround(ref: CollectionReference, center: GeoPoint, radiusInKm: number): any {
        const geohashesToQuery = this.geohashQueries([center.latitude, center.longitude], radiusInKm * 1000);
        const ret = geohashesToQuery.map( (location: any) => {
            return ref.where('geohash', '>=', location[0]).where('geohash', '<=', location[1]);
        });
        return ret;
    }
}






